import { HowItWorks } from "modules/experiments/HowItWorks";

const HowItWorksAdapter = () => <HowItWorks />;

export default HowItWorksAdapter;
